/**
 * Carry the chosen size across a colour change.
 *
 * Colours are separate products, so changing colour is a navigation. Without
 * this the sibling loads on its own first available variant, which is why a
 * sold out size silently became the next size up. Each colour swatch carries a
 * map of variant title to variant id, so the link is rewritten to the matching
 * variant on the sibling. Shopify then selects that variant on arrival, and the
 * picker shows it struck through when it is sold out rather than moving on.
 */

function parseVariantMap(raw) {
  const map = new Map();
  if (!raw) return map;

  raw.split('@@').forEach((pair) => {
    const [title, id] = pair.split('::');
    if (title && id) map.set(title.trim(), id.trim());
  });

  return map;
}

function selectedVariantTitle(scope) {
  const checked = Array.from(
    scope.querySelectorAll('variant-picker input[type="radio"]:checked, .variant-option input[type="radio"]:checked')
  );

  if (checked.length === 0) return null;

  return checked
    .map((input) => input.value.trim())
    .join(' / ');
}

function updateLinks() {
  const options = document.querySelectorAll('[data-colour-option]');
  if (options.length === 0) return;

  const scope = document.querySelector('product-form-component, .product-information, main') || document;
  const title = selectedVariantTitle(scope);

  options.forEach((option) => {
    const base = option.dataset.baseUrl;
    if (!base) return;

    if (!title) {
      option.setAttribute('href', base);
      return;
    }

    const map = parseVariantMap(option.dataset.variantMap);
    const variantId = map.get(title);

    // No matching size on that colour, so fall back to the plain product page
    // rather than sending the customer to a variant that does not exist.
    option.setAttribute('href', variantId ? `${base}?variant=${variantId}` : base);
  });
}

updateLinks();

document.addEventListener('change', (event) => {
  if (event.target.matches('input[type="radio"]')) updateLinks();
});

document.addEventListener('variant:update', updateLinks);
document.addEventListener('shopify:section:load', updateLinks);
